module.exports = __webpack_public_path__ + "static/img/3.dab658a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/3.png
// module id = br6N
// module chunks = 0